import { throwIfAborted } from '../abort.js';
import { OnrampApiError, } from '../client.js';
const cooldowns = new WeakMap();
const POLL_MS = 7000;
/** A client-wide guard prevents filter changes and realtime invalidation bypassing rate limits. */
export async function fetchHistoryWithCooldown(client, options, signal) {
    throwIfAborted(signal);
    const cooldown = cooldowns.get(client);
    if (cooldown && cooldown.until > Date.now())
        throw cooldown.error;
    try {
        const history = await client.getHistory(options, signal);
        if (cooldowns.get(client) === cooldown)
            cooldowns.delete(client);
        return history;
    }
    catch (error) {
        if (!signal.aborted &&
            error instanceof OnrampApiError &&
            (error.status === 429 || error.retryAfterMs > 0)) {
            const delay = Number.isFinite(error.retryAfterMs) && error.retryAfterMs > 0
                ? Math.min(2147483647, error.retryAfterMs)
                : POLL_MS;
            const until = Math.max(cooldowns.get(client)?.until ?? 0, Date.now() + delay);
            cooldowns.set(client, { until, error });
        }
        throw error;
    }
}
export function historyRefetchInterval(client) {
    const remaining = (cooldowns.get(client)?.until ?? 0) - Date.now();
    return remaining > 0 ? remaining : POLL_MS;
}
